<template>
  <div class="container">
    <InformationManage :tag="tagList" />
  </div>
</template>

<script>
import InformationManage from '@/views/informationManage/index.vue'
export default {
  components: { InformationManage },
  data () {
    return {
      tagList: [
        {
          label: '网络主播',
          value: 6
        },
        {
          label: '全媒体运营师',
          value: 7
        },
        {
          label: '网络信息审核员',
          value: 8
        },
        {
          label: 'AIGC视听创制师',
          value: 20
        },
      ]
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
